
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/accreditation",
      function () {
        return require("private-next-pages/page/[subdomain]/accreditation/index.tsx");
      }
    ]);
  